import { render, staticRenderFns } from "./HistorySMS.vue?vue&type=template&id=66738815&scoped=true"
import script from "./HistorySMS.vue?vue&type=script&lang=js"
export * from "./HistorySMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66738815",
  null
  
)

export default component.exports